import { useState } from 'react';
import { FaChevronDown, FaChevronRight } from 'react-icons/fa6';
import { useNavigate } from 'react-router-dom';
import { LocationMapItem } from '../../types/place.types';
import './StateAccordionComponent.css';

interface StateAccordionParams {
  stateName: string;
  stateFranchises: LocationMapItem[] | undefined;
}

const StateAccordionComponent: React.FC<StateAccordionParams> = ({
                                                                   stateName,
                                                                   stateFranchises
                                                                 }) => {
  const [toggleContent, setToggleContent] = useState(false);
  const navigate = useNavigate();

  const handleToggle = () => {
    const toggleValue = !toggleContent;
    setToggleContent(toggleValue);
  };

  let className = 'nav-item';
  if (toggleContent) {
    className += ' active';
  }

  return (
      <div className={className}>
        <div
            className="nav-link"
            onClick={handleToggle}
        >
          <span className="state-name">{stateName}</span>
          <span className="arrow">{toggleContent ? <FaChevronDown /> : <FaChevronRight />}</span>
        </div>
        {toggleContent &&
            stateFranchises?.map((franchise) => (
                <p
                    key={franchise.id}
                    className="location-text"
                    onClick={() => navigate('/franchise/' + franchise.slug)}
                >
                  {franchise.title}
                </p>
            ))}
      </div>
  );
};

export default StateAccordionComponent;